import React, {Component, PropTypes} from 'react'
import {mediaQuery} from '../../core/browser'
import extract from '../../core/extract'
import SearchBar from '../../core/components/SearchBar'
import i18n from '../i18n'


class TicketClaimSearchBar extends Component {
    static propTypes = {
    }

    render() {
        return (
        	<SearchBar
                placeholder={extract(i18n.searchStream, mediaQuery())}>
        	</SearchBar>
        )
    }
}

export default TicketClaimSearchBar


// WEBPACK FOOTER //
// ./lib/claim/components/TicketClaimSearchBar.js